module.exports = __webpack_public_path__ + "static/media/round-favorite-border-24-px.41b76c94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/round-favorite-border-24-px.svg
// module id = 766
// module chunks = 0